export default __webpack_public_path__ + "c9d9d13625365bb0addfe177087a1e5f.png";